export default defineNuxtRouteMiddleware((to, from) => {
    const { status } = useAuth();

    if (status.value === "authenticated") {
        if (to.path === "/auth/login") return navigateTo("/admin/dashboard");
        return navigateTo("/admin/dashboard");
    }
});
